import React from "react";
import BlogListPage from "src/components/BlogListPage/BlogListPage";
import { GetStaticProps } from "next";
import { MetaDataPage, MetaDataPageType } from "src/models/meta/getMetaData";
import MetaContainer from "src/components/common/Layout/components/MetaContainer/MetaContainer";
import { requestBlogPage } from "src/utils/helpers/requestApi/serverFetchPage/requestBlogPage";
import { LastArticlesSchema } from "src/models/articles/getLastArticles";

interface BlogListProps {
  articlesData: LastArticlesSchema;
}

const BlogList: React.FC<MetaDataPage & BlogListProps> = ({
  metaData,
  articlesData,
}) => {
  return (
    <MetaContainer {...metaData}>
      <BlogListPage pageTitle={metaData.h1} articlesData={articlesData} />
    </MetaContainer>
  );
};

export const getStaticProps: GetStaticProps = requestBlogPage.bind(
  null,
  MetaDataPageType.blogArticles,
  false
);

export default BlogList;
